module.exports = __webpack_public_path__ + "static/media/wash-iron.a47c473a.jpeg";